// // src/components/panels/RiskManagementPanel.jsx
// import React, { useState } from "react";
// import { PlusCircle, Trash2, Edit } from "lucide-react";
// import { toast } from "react-toastify";
// import { createRisk, deleteRisk, updateRisk } from "../../api/riskApi"; // You'll need to create this API service

// const RiskManagementPanel = ({ projectId, risks, onUpdate }) => {
//     const [newRisk, setNewRisk] = useState({
//         title: "",
//         description: "",
//         likelihood: "Low", // Default value
//         impact: "Low", // Default value
//         mitigationPlan: "",
//         status: "Open" // Default status
//     });
//     const [isAdding, setIsAdding] = useState(false);
//     const [editingRisk, setEditingRisk] = useState(null);

//     const handleAddRisk = async (e) => {
//         e.preventDefault();
//         try {
//             await createRisk({ ...newRisk, project: projectId });
//             toast.success("Risk added successfully!");
//             setNewRisk({
//                 title: "",
//                 description: "",
//                 likelihood: "Low",
//                 impact: "Low",
//                 mitigationPlan: "",
//                 status: "Open"
//             });
//             setIsAdding(false);
//             onUpdate();
//         } catch (error) {
//             toast.error("Failed to add risk.");
//             console.error(error);
//         }
//     };

//     const handleDeleteRisk = async (riskId) => {
//         if (window.confirm("Are you sure you want to delete this risk?")) {
//             try {
//                 await deleteRisk(riskId);
//                 toast.success("Risk deleted successfully!");
//                 onUpdate();
//             } catch (error) {
//                 toast.error("Failed to delete risk.");
//                 console.error(error);
//             }
//         }
//     };

//     return (
//         <div className="flex flex-col h-full">
//             <button
//                 onClick={() => setIsAdding(!isAdding)}
//                 className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg flex items-center justify-center transition duration-300 shadow-md mb-4"
//             >
//                 <PlusCircle size={20} className="mr-2" /> {isAdding ? "Cancel" : "Identify New Risk"}
//             </button>

//             {isAdding && (
//                 <form onSubmit={handleAddRisk} className="bg-white p-4 rounded-lg shadow-inner mb-4">
//                     <h4 className="font-semibold mb-2">New Risk</h4>
//                     <input
//                         type="text"
//                         placeholder="Risk Title"
//                         value={newRisk.title}
//                         onChange={(e) => setNewRisk({ ...newRisk, title: e.target.value })}
//                         required
//                         className="w-full mb-2 p-2 border rounded"
//                     />
//                     <textarea
//                         placeholder="Description & Mitigation Plan"
//                         value={newRisk.description}
//                         onChange={(e) => setNewRisk({ ...newRisk, description: e.target.value })}
//                         rows="3"
//                         className="w-full mb-2 p-2 border rounded"
//                     />
//                     <div className="flex space-x-2 mb-2">
//                         <select
//                             value={newRisk.likelihood}
//                             onChange={(e) => setNewRisk({ ...newRisk, likelihood: e.target.value })}
//                             className="flex-1 p-2 border rounded"
//                         >
//                             <option>Low</option>
//                             <option>Medium</option>
//                             <option>High</option>
//                         </select>
//                         <select
//                             value={newRisk.impact}
//                             onChange={(e) => setNewRisk({ ...newRisk, impact: e.target.value })}
//                             className="flex-1 p-2 border rounded"
//                         >
//                             <option>Low</option>
//                             <option>Medium</option>
//                             <option>High</option>
//                         </select>
//                     </div>
//                     <button type="submit" className="w-full bg-green-500 text-white p-2 rounded hover:bg-green-600 transition">
//                         Save Risk
//                     </button>
//                 </form>
//             )}

//             <div className="flex-grow overflow-y-auto space-y-3">
//                 {risks.length > 0 ? (
//                     risks.map((risk) => (
//                         <div key={risk._id} className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
//                             <div className="flex justify-between items-center mb-2">
//                                 <h4 className="font-bold text-gray-800">{risk.title}</h4>
//                                 <div className="flex space-x-2">
//                                     <span className={`text-xs font-semibold px-2 py-1 rounded-full ${
//                                         risk.status === 'Open' ? 'bg-red-100 text-red-800' :
//                                         risk.status === 'Mitigated' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
//                                     }`}>
//                                         {risk.status}
//                                     </span>
//                                     <button onClick={() => setEditingRisk(risk)} title="Edit Risk" className="text-gray-500 hover:text-gray-700">
//                                         <Edit size={16} />
//                                     </button>
//                                     <button onClick={() => handleDeleteRisk(risk._id)} title="Delete Risk" className="text-red-500 hover:text-red-700">
//                                         <Trash2 size={16} />
//                                     </button>
//                                 </div>
//                             </div>
//                             <p className="text-sm text-gray-600 mb-2">{risk.description}</p>
//                             <div className="flex items-center text-sm text-gray-500">
//                                 <span className="mr-2">Likelihood: <span className="font-semibold">{risk.likelihood}</span></span>
//                                 <span>Impact: <span className="font-semibold">{risk.impact}</span></span>
//                             </div>
//                         </div>
//                     ))
//                 ) : (
//                     <div className="text-center text-gray-500 p-8">No risks identified for this project.</div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default RiskManagementPanel;

// RiskManagementPanel.js
import React, { useState } from "react";
import { PlusCircle, Trash2, Edit, AlertTriangle } from "lucide-react";
import { toast } from "react-toastify";
import { createRisk, deleteRisk, updateRisk } from "../../api/riskApi";

const RiskManagementPanel = ({ projectId, risks, onUpdate }) => {
    const [newRisk, setNewRisk] = useState({
        title: "",
        description: "",
        likelihood: "Medium",
        impact: "Medium",
        mitigationPlan: "",
        status: "Open"
    });
    const [isAdding, setIsAdding] = useState(false);
    const [editingRisk, setEditingRisk] = useState(null);
    const [editForm, setEditForm] = useState({
        title: "",
        description: "",
        likelihood: "Medium",
        impact: "Medium",
        mitigationPlan: "",
        status: "Open"
    });

    // Initialize edit form when editingRisk changes
    React.useEffect(() => {
        if (editingRisk) {
            setEditForm({
                title: editingRisk.title,
                description: editingRisk.description,
                likelihood: editingRisk.likelihood,
                impact: editingRisk.impact,
                mitigationPlan: editingRisk.mitigationPlan,
                status: editingRisk.status
            });
        }
    }, [editingRisk]);

    const handleAddRisk = async (e) => {
        e.preventDefault();
        try {
            await createRisk({ ...newRisk, project: projectId });
            toast.success("Risk added successfully!");
            setNewRisk({
                title: "",
                description: "",
                likelihood: "Medium",
                impact: "Medium",
                mitigationPlan: "",
                status: "Open"
            });
            setIsAdding(false);
            onUpdate();
        } catch (error) {
            toast.error("Failed to add risk.");
            console.error(error);
        }
    };

    const handleDeleteRisk = async (riskId) => {
        if (window.confirm("Are you sure you want to delete this risk?")) {
            try {
                await deleteRisk(riskId);
                toast.success("Risk deleted successfully!");
                onUpdate();
            } catch (error) {
                toast.error("Failed to delete risk.");
                console.error(error);
            }
        }
    };

    const handleUpdateRisk = async (e) => {
        e.preventDefault();
        try {
            await updateRisk(editingRisk._id, editForm);
            toast.success("Risk updated successfully!");
            setEditingRisk(null);
            onUpdate();
        } catch (error) {
            toast.error("Failed to update risk.");
            console.error(error);
        }
    };

    const getRiskColor = (likelihood, impact) => {
        const score = (likelihood === 'High' ? 3 : likelihood === 'Medium' ? 2 : 1) * 
                     (impact === 'High' ? 3 : impact === 'Medium' ? 2 : 1);
        if (score >= 6) return 'bg-red-100 border-red-300';
        if (score >= 3) return 'bg-yellow-100 border-yellow-300';
        return 'bg-green-100 border-green-300';
    };

    return (
        <div className="flex flex-col h-full">
            <div className="mb-6 bg-red-50 p-4 rounded-lg border border-red-200">
                <h3 className="font-semibold text-red-800 mb-2">Risk Management for South Sudan Operations</h3>
                <p className="text-sm text-red-700">
                    Identify and mitigate risks specific to operating in South Sudan, including security, regulatory, and operational risks.
                </p>
            </div>
            
            <button
                onClick={() => setIsAdding(!isAdding)}
                className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg flex items-center justify-center transition duration-300 shadow-md mb-4"
            >
                <PlusCircle size={20} className="mr-2" /> {isAdding ? "Cancel" : "Identify New Risk"}
            </button>

            {isAdding && (
                <form onSubmit={handleAddRisk} className="bg-white p-4 rounded-lg shadow-inner mb-4 border border-gray-200">
                    <h4 className="font-semibold mb-3 text-gray-800">Add New Risk</h4>
                    <input
                        type="text"
                        placeholder="Risk Title"
                        value={newRisk.title}
                        onChange={(e) => setNewRisk({ ...newRisk, title: e.target.value })}
                        required
                        className="w-full mb-3 p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                    />
                    <textarea
                        placeholder="Description & Mitigation Plan"
                        value={newRisk.description}
                        onChange={(e) => setNewRisk({ ...newRisk, description: e.target.value })}
                        rows="3"
                        className="w-full mb-3 p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                    />
                    <div className="grid grid-cols-2 gap-3 mb-3">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Likelihood</label>
                            <select
                                value={newRisk.likelihood}
                                onChange={(e) => setNewRisk({ ...newRisk, likelihood: e.target.value })}
                                className="w-full p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                            >
                                <option>Low</option>
                                <option>Medium</option>
                                <option>High</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Impact</label>
                            <select
                                value={newRisk.impact}
                                onChange={(e) => setNewRisk({ ...newRisk, impact: e.target.value })}
                                className="w-full p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                            >
                                <option>Low</option>
                                <option>Medium</option>
                                <option>High</option>
                            </select>
                        </div>
                    </div>
                    <button type="submit" className="w-full bg-green-600 text-white p-2 rounded hover:bg-green-700 transition">
                        Save Risk
                    </button>
                </form>
            )}

            {editingRisk && (
                <form onSubmit={handleUpdateRisk} className="bg-white p-4 rounded-lg shadow-inner mb-4 border border-gray-200">
                    <div className="flex justify-between items-center mb-3">
                        <h4 className="font-semibold text-gray-800">Edit Risk</h4>
                        <button 
                            type="button" 
                            onClick={() => setEditingRisk(null)} 
                            className="text-gray-500 hover:text-gray-700"
                        >
                            Cancel
                        </button>
                    </div>
                    <input
                        type="text"
                        placeholder="Risk Title"
                        value={editForm.title}
                        onChange={(e) => setEditForm({ ...editForm, title: e.target.value })}
                        required
                        className="w-full mb-3 p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                    />
                    <textarea
                        placeholder="Description & Mitigation Plan"
                        value={editForm.description}
                        onChange={(e) => setEditForm({ ...editForm, description: e.target.value })}
                        rows="3"
                        className="w-full mb-3 p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                    />
                    <div className="grid grid-cols-2 gap-3 mb-3">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Likelihood</label>
                            <select
                                value={editForm.likelihood}
                                onChange={(e) => setEditForm({ ...editForm, likelihood: e.target.value })}
                                className="w-full p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                            >
                                <option>Low</option>
                                <option>Medium</option>
                                <option>High</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Impact</label>
                            <select
                                value={editForm.impact}
                                onChange={(e) => setEditForm({ ...editForm, impact: e.target.value })}
                                className="w-full p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                            >
                                <option>Low</option>
                                <option>Medium</option>
                                <option>High</option>
                            </select>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                        <select
                            value={editForm.status}
                            onChange={(e) => setEditForm({ ...editForm, status: e.target.value })}
                            className="w-full p-2 border rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                        >
                            <option>Open</option>
                            <option>In Progress</option>
                            <option>Mitigated</option>
                            <option>Closed</option>
                        </select>
                    </div>
                    <button type="submit" className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700 transition">
                        Update Risk
                    </button>
                </form>
            )}

            <div className="flex-grow overflow-y-auto space-y-3">
                {risks.length > 0 ? (
                    risks.map((risk) => (
                        <div 
                            key={risk._id} 
                            className={`p-4 rounded-lg shadow-sm border ${getRiskColor(risk.likelihood, risk.impact)}`}
                        >
                            <div className="flex justify-between items-start mb-2">
                                <div>
                                    <h4 className="font-bold text-gray-800 flex items-center">
                                        <AlertTriangle className="mr-2 text-orange-500" size={18} />
                                        {risk.title}
                                    </h4>
                                    <div className="flex items-center mt-1">
                                        <span className={`text-xs font-semibold px-2 py-1 rounded-full mr-2 ${
                                            risk.status === 'Open' ? 'bg-red-100 text-red-800' :
                                            risk.status === 'In Progress' ? 'bg-yellow-100 text-yellow-800' :
                                            risk.status === 'Mitigated' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                                        }`}>
                                            {risk.status}
                                        </span>
                                        <span className="text-xs text-gray-600">
                                            {risk.likelihood} Likelihood, {risk.impact} Impact
                                        </span>
                                    </div>
                                </div>
                                <div className="flex space-x-2">
                                    <button 
                                        onClick={() => setEditingRisk(risk)} 
                                        title="Edit Risk" 
                                        className="text-gray-500 hover:text-gray-700"
                                    >
                                        <Edit size={16} />
                                    </button>
                                    <button 
                                        onClick={() => handleDeleteRisk(risk._id)} 
                                        title="Delete Risk" 
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            </div>
                            <p className="text-sm text-gray-700 mt-2">{risk.description}</p>
                            {risk.mitigationPlan && (
                                <div className="mt-3 p-2 bg-white rounded border border-gray-200">
                                    <p className="text-xs font-medium text-gray-700 mb-1">Mitigation Plan:</p>
                                    <p className="text-sm text-gray-600">{risk.mitigationPlan}</p>
                                </div>
                            )}
                        </div>
                    ))
                ) : (
                    <div className="text-center text-gray-500 p-8 bg-white rounded-lg border border-gray-200">
                        <AlertTriangle className="mx-auto text-gray-400 mb-3" size={32} />
                        <p>No risks identified for this project.</p>
                        <p className="text-sm mt-2">Click "Identify New Risk" to add potential risks.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RiskManagementPanel;